import React, { useState } from 'react';
import { Home, CheckCircle2, ShieldCheck, Zap } from 'lucide-react';
import { AddPropertyModal } from './AddPropertyModal';

export const AddPropertySection = () => {
  const [open, setOpen] = useState(false);

  return (
    <section
      id="add-property"
      className="am-reveal py-20 bg-gradient-to-br from-emerald-700 via-emerald-800 to-emerald-900 relative overflow-hidden"
    >
      <div className="absolute -top-24 -right-24 w-80 h-80 bg-amber-400/15 rounded-full blur-3xl pointer-events-none"></div>
      <div className="absolute -bottom-24 -left-24 w-80 h-80 bg-emerald-400/10 rounded-full blur-3xl pointer-events-none"></div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <div>
            <div className="inline-flex items-center gap-2 px-3 py-1 bg-amber-400/15 border border-amber-300/30 rounded-full mb-4">
              <Zap size={12} className="text-amber-300" />
              <span className="text-[10px] font-bold tracking-[0.18em] uppercase text-amber-200">
                Sell / Rent with Acre Mitra
              </span>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 leading-tight">
              Got a property? <span className="text-amber-300">List it with us.</span>
            </h2>
            <p className="text-emerald-50/85 text-base md:text-lg leading-relaxed mb-6">
              Reach thousands of verified buyers across India. Add your land, plot, flat, or house in
              under 2 minutes — our team will verify, photograph and market your property for the
              best deal.
            </p>
            <ul className="space-y-3 text-emerald-50 mb-7">
              <li className="flex items-center gap-2.5">
                <CheckCircle2 size={18} className="text-amber-300 flex-shrink-0" />
                <span className="text-sm">Free listing — no upfront fees</span>
              </li>
              <li className="flex items-center gap-2.5">
                <ShieldCheck size={18} className="text-amber-300 flex-shrink-0" />
                <span className="text-sm">Verified buyers, document checks & dedicated agent</span>
              </li>
              <li className="flex items-center gap-2.5">
                <CheckCircle2 size={18} className="text-amber-300 flex-shrink-0" />
                <span className="text-sm">Detailed reports sent direct to your phone</span>
              </li>
            </ul>
            <button
              onClick={() => setOpen(true)}
              className="btn-am-accent text-base px-8 py-4"
              data-testid="add-property-open"
            >
              <Home size={18} />
              Add Your Property
            </button>
          </div>

          {/* Visual card */}
          <div className="hidden md:block">
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/15 max-w-md ml-auto">
              <img
                src="https://images.unsplash.com/photo-1486325212027-8081e485255e?w=900&q=80"
                alt="Indian property aerial view"
                className="w-full h-56 object-cover rounded-xl mb-4"
              />
              <div className="grid grid-cols-3 gap-3 text-center">
                <div>
                  <div className="text-2xl font-bold text-amber-300">2 min</div>
                  <div className="text-[10px] uppercase tracking-wider text-emerald-100/70">to list</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-amber-300">1000+</div>
                  <div className="text-[10px] uppercase tracking-wider text-emerald-100/70">buyers</div>
                </div>
                <div>
                  <div className="text-2xl font-bold text-amber-300">0%</div>
                  <div className="text-[10px] uppercase tracking-wider text-emerald-100/70">upfront</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddPropertyModal isOpen={open} onClose={() => setOpen(false)} />
    </section>
  );
};

export default AddPropertySection;
